<template>
  <div class="file-man">
    <!-- 面包屑 -->
    <Breadcrumb :crumb="crumb">
      <template>
        <el-button class="fr" size="small" @click="toBack"
          >返回</el-button
        ></template
      ></Breadcrumb
    >
    <div class="contain">
      <el-form ref="form" :rules="rules" :model="form" label-width="130px">
        <el-form-item label="手册标题" prop="bookName">
          <el-input
            size="large"
            clearable
            style="width: 300px"
            placeholder="请输入"
            v-model="form.bookName"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>

        <el-form-item label="对应模块" prop="integralModel">
          <el-select v-model="form.integralModel" placeholder="请选择">
            <el-option
              v-for="item in scoreMenuList"
              :key="item.menuCode"
              :label="item.menuName"
              :value="item.menuCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div
          v-for="(paragraph, index) in form.paragraphList"
          :key="paragraph.key"
          class="paragraphList"
        >
          <div class="index">{{ index + 1 }}、</div>
          <div class="content">
            <i
              v-if="form.paragraphList.length > 1"
              class="delete el-icon-delete"
              @click="deleteParagraph(index)"
            ></i>
            <el-form-item label="节点标题" prop="paraTitle">
              <el-input
                clearable
                placeholder="请输入"
                v-model="paragraph.paraTitle"
                maxlength="50"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item label="操作说明" prop="paraContent">
              <el-input
                style="min-width: 400px"
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 6 }"
                v-model="paragraph.paraContent"
              ></el-input>
            </el-form-item>
            <el-form-item label="上传附件" prop="paraAttaches">
              <upload
                :allowType="2"
                :fileLimit="50"
                :limit="10"
                :fileList="paragraph.paraAttaches"
                @uploadFileUrl="(url, list) => uploadFileUrl(url, list, index)"
              >
              </upload>
            </el-form-item>
          </div>
        </div>
        <el-button
          style="margin: 20px 50px"
          type="primary"
          @click="addParagraph"
          >添加节点</el-button
        >
        <div class="submit">
          <el-button style="margin: 20px 50px" type="primary" @click="submit"
            >保存</el-button
          >
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import { mapState } from "vuex";
import Upload from "@/components/Upload.vue";
import { get } from "http";
export default {
  components: {
    Breadcrumb,
    Upload,
  },
  computed: {
    ...mapState(["scoreMenuList", "userInfo", "isAdmin"]),
    exData() {
      return {
        integralModel: this.menuCodeMix,
        schoolCode: this.userInfo.schoolCode,
      };
    },
  },
  data() {
    return {
      //面包屑
      crumb: {
        list: ["操作手册", "创建"],
        titBig: "操作手册",
      },
      form: {
        id: "",
        bookCode: "",
        bookName: "",
        integralModel: "",
        paragraphList: [
          {
            paraAttaches: [],
            paraTitle: "",
            paraContent: "",
          },
        ],
      },
      rules: {
        integralModel: [
          {
            required: true,
            message: "请选择对应模块",
            trigger: ["change", "blur"],
          },
        ],
        bookName: [
          {
            required: true,
            message: "请输入手册标题",
            trigger: ["change", "blur"],
          },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: ["change", "blur"],
          },
        ],
        // paraTitle: [
        //   {
        //     required: true,
        //     message: "节点标题不能为空",
        //     trigger: "blur",
        //   },
        // ],
        // paragraphList: [
        //   {
        //     paraContent: [
        //       {
        //         required: true,
        //         message: "操作说明不能为空",
        //         trigger: "blur",
        //       },
        //     ],
        //   },
        //   {
        //     paraAttaches: [
        //       {
        //         required: true,
        //         message: "请上传附件",
        //         trigger: ["change", "blur"],
        //       },
        //     ],
        //   },
        // ],
        // paraContent: [
        //   {
        //     required: true,
        //     message: "操作说明不能为空",
        //     trigger: "blur",
        //   },
        // ],
        // paraAttaches: [
        //   {
        //     required: true,
        //     message: "请上传附件",
        //     trigger: ["change", "blur"],
        //   },
        // ],
      },
    };
  },
  created() {
    if (this.$route.query.bookCode) {
      (this.crumb.list = ["操作手册", "编辑"]),
        this.getBookInfo(this.$route.query.bookCode);
    }
  },
  methods: {
    getBookInfo(bookCode) {
      this.$axios
        .post(
          "/handbook/getHandBookInfoDetail",
          this.$qs.stringify({
            schoolCode: this.userInfo.schoolCode,
            bookCode,
          })
        )
        .then(({ data }) => {
          this.form.id = data.id;
          this.form.bookCode = data.bookCode;
          this.form.bookName = data.bookName;
          this.form.integralModel = data.integralModel;
          this.form.paragraphList = data.paragraphList;
        });
    },
    toBack() {
      this.$router.push({
        path: "/common/service-manual",
      });
    },
    deleteParagraph(index) {
      this.form.paragraphList.splice(index, 1);
    },
    addParagraph() {
      this.form.paragraphList.push({
        paraAttaches: [],
        paraTitle: "",
        paraContent: "",
      });
    },
    uploadFileUrl(fileUrl, fileList, index) {
      this.form.paragraphList = this.form.paragraphList?.map((u, i) => {
        if (index == i) {
          if (u.paraAttaches <= fileList) {
            //登录成功
            this.$message({
              message: "上传成功",
              type: "success",
              duration: 2000,
              offset: 150,
            });
          }
          return {
            ...u,
            paraAttaches: fileList,
          };
        } else {
          return u;
        }
      });
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.paragraphList.length == 0) {
            return;
          } else {
            let isNull = false;
            if (this.form.paragraphList) {
              this.form.paragraphList.forEach((item) => {
                if (
                  item.paraTitle == "" ||
                  item.paraContent == "" ||
                  item.paraAttaches.length == 0
                ) {
                  isNull = true;
                }
              });
            }
            if (isNull) {
              this.$message({
                message: "请填写完整",
                type: "warning",
                duration: 2000,
                offset: 150,
              });
            } else {
              this.$axios
                .post("/handbook/saveOrUpdateHandBookInfo", {
                  ...this.form,
                  schoolCode: this.userInfo.schoolCode,
                  operatorId: this.userInfo.userId,
                })
                .then((res) => {
                  if (res.resultCode === 200) {
                    this.$refs.form.resetFields();
                    this.toBack();
                    this.$message({
                      message: "更新成功",
                      type: "success",
                      duration: 2000,
                      offset: 150,
                    });
                  }
                });
            }
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.file-man {
  padding: 18px;
  border-radius: 8px;
  .el-button {
    background: @theme-color;
    color: #fff;
    font-size: 14px;

    /deep/.iconfont {
      font-size: 15px;
      margin-right: 5px;
    }
  }

  .contain {
    background: #fff;
    padding: 20px;
    border-radius: 20px;
    .el-input {
      // width: unset !important;
    }
    .paragraphList {
      margin: 50px 0;
      display: flex;

      .index {
        width: 50px;
        text-align: right;
      }
      .content {
        border-radius: 10px;
        padding: 50px 20px 20px;
        background-color: #cccccc4a;
        position: relative;
        .delete {
          position: absolute;
          top: 0;
          right: -24px;
          font-size: 24px;
          cursor: pointer;

          &:hover {
            color: @theme-color;
          }
        }
      }
    }
    .submit {
      display: flex;
      justify-content: center;
    }
  }
}
</style>
